import React, { useCallback, useEffect, useState } from 'react';
import { Typography, Grid, useTheme } from '@mui/material';
import { Card, DatePicker, ValidatorForm } from 'components'; // Assuming DatePicker is a custom component
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import DashboardServices from 'services/DashboardServices';
import moment from 'moment';

const IncidentsByLocation = ({ filters }) => {
        const theme = useTheme();
    const [params, setParams] = useState({
        from_date: moment().subtract(15, 'days').toISOString(),
        to_date: moment().toISOString()
    });
    const [data, setData] = useState([]);

    const getData = useCallback(async () => {
        const response = await DashboardServices.getIncidetByLocation({ ...params, ...filters });
        if (response.success) {
            setData(response?.data || []);
        }
    }, [params, filters]);

    useEffect(() => {
        getData();
    }, [getData]);

    const handleDateChange = (field, date) => {
        setParams({ ...params, [field]: date });
    };

    const containerStyle = {
        borderRadius: '8px',
    };

    return (
        <Card className="p-4" style={containerStyle}>
            <Typography variant='h6'>Incidents by Location</Typography>
            <ValidatorForm className="mt-3">
                <Grid container spacing={2} columns={8}>
                    <Grid item size={{ lg: 4, md: 4, sm: 12, xs: 12 }}>
                        <DatePicker
                            label="From Date"
                            value={new Date(params.from_date)}
                            onChange={(date) => handleDateChange('from_date', date)}
                        />
                    </Grid>
                    <Grid item size={{ lg: 4, md: 4, sm: 12, xs: 12 }}>
                        <DatePicker
                            label="To Date"
                            value={new Date(params.to_date)}
                            onChange={(date) => handleDateChange('to_date', date)}
                        />
                    </Grid>
                </Grid>
            </ValidatorForm>

            <ResponsiveContainer className="mt-5" width="100%" height={325}>
                <BarChart data={data}>
                    <defs>
                        <linearGradient id="colorAllIncidents" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#ef9023" stopOpacity={0.6} />
                            <stop offset="95%" stopColor="#ef9023" stopOpacity={0.9} />
                        </linearGradient>
                        <linearGradient id="colorPending" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#0686dc" stopOpacity={0.6} />
                            <stop offset="95%" stopColor="#0686dc" stopOpacity={0.9} />
                        </linearGradient>
                        <linearGradient id="colorFixed" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#ed5700" stopOpacity={0.6} />
                            <stop offset="95%" stopColor="#ed5700" stopOpacity={0.9} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="location" stroke={theme.palette.text.primary}/>
                    <YAxis allowDecimals={false} domain={[0, 'dataMax + 1']}stroke={theme.palette.text.primary}/>
                    <Tooltip
                        labelStyle={{ color: '#363636' }}
                        contentStyle={{ color: '#363636' }}
                    />
                    <Legend />
                    <Bar dataKey="all_incidents" fill="url(#colorAllIncidents)" />
                    <Bar dataKey="pending" fill="url(#colorPending)" />
                    <Bar dataKey="fixed" fill="url(#colorFixed)" />
                </BarChart>
            </ResponsiveContainer>
        </Card>
    );
};

export default IncidentsByLocation;